import {
  MonacoFileEditor,
  type MonacoFileEditorProps
} from '../monacoFileEditor/MonacoFileEditor';

export type CodeEditorPageProps = Omit<MonacoFileEditorProps, 'mode'>;

/** Code Editor shell for code/config files with browser intelligence UX. */
export function CodeEditorPage(props: CodeEditorPageProps) {
  return <MonacoFileEditor {...props} mode="code" />;
}
